export const SET_TABLE_PROCESS = 'SET_TABLE_PROCESS';

export const setTableProcess = (processType, entityType, ids) => ({
  type: SET_TABLE_PROCESS,
  payload: { processType, entityType, ids },
});
